module.exports = __webpack_public_path__ + "img/poker-h06.7103f5ea.svg";